(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!form.matches('[data-cart-remove-form]') || event.defaultPrevented) return;
  const section = form.closest('[data-cart-section]');
  if (!section) return;
  if (section.dataset.removing === 'true') {
    event.preventDefault();
    return;
  }
  section.dataset.removing = 'true';
  section.querySelectorAll('[data-cart-remove-button]').forEach((button) => {
    button.disabled = true;
  });
});
window.addEventListener('pageshow', (event) => {
  if (event.persisted && document.querySelector('[data-cart-section]')) window.location.reload();
});

  } catch(e) { console.error(e); }
})();
})();
